import React from 'react';
import { Ticket, CheckCircle, Gift } from 'lucide-react';

const CouponsTab = ({ couponData, vipEmail, setVipEmail, vipCreating, vipResult, handleCreateVIP }) => (
  <div className="coupon-section" data-testid="coupon-dashboard">
    <div className="analytics-cards">
      <div className="analytics-card">
        <Ticket size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{couponData?.total || 0}</span>
          <span className="analytics-card-label">Total Kupon</span>
        </div>
      </div>
      <div className="analytics-card">
        <CheckCircle size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{couponData?.used || 0}</span>
          <span className="analytics-card-label">Digunakan</span>
        </div>
      </div>
      <div className="analytics-card accent">
        <Gift size={22} />
        <div className="analytics-card-data">
          <span className="analytics-card-value">{couponData?.available || 0}</span>
          <span className="analytics-card-label">Tersedia</span>
        </div>
      </div>
    </div>

    {couponData?.tier_stats?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading">Kupon per Tier</h3>
        <div className="stages-grid">
          {couponData.tier_stats.map((t, i) => (
            <div key={i} className="stage-card">
              <div className="stage-number">{t.used}/{t.count}</div>
              <div className="stage-info"><h4>{t.tier}</h4><p className="stage-count">{t.count - t.used} tersedia</p></div>
            </div>
          ))}
        </div>
      </div>
    )}

    <div className="analytics-panel" data-testid="vip-coupon-panel">
      <h3 className="section-heading">Buat VIP Kupon (100% Gratis)</h3>
      <p style={{color: '#888680', fontSize: '0.875rem', marginBottom: '1rem'}}>Berikan buku gratis kepada member spesial. Kupon akan otomatis dikirim via email.</p>
      <form onSubmit={handleCreateVIP} className="vip-form">
        <input type="email" value={vipEmail} onChange={(e) => setVipEmail(e.target.value)} placeholder="Email subscriber" required className="vip-input" data-testid="vip-email-input" />
        <button type="submit" disabled={vipCreating} className="scheduler-trigger-btn" data-testid="vip-create-btn">
          <Gift size={18} /> {vipCreating ? 'Membuat...' : 'Buat VIP Kupon'}
        </button>
      </form>
      {vipResult && (
        <div className={`scheduler-trigger-result ${vipResult.success ? 'success' : 'warning'}`}>
          {vipResult.message}
          {vipResult.code && <span style={{marginLeft: '8px', fontWeight: 700}}>{vipResult.code}</span>}
        </div>
      )}
    </div>

    {couponData?.coupons?.length > 0 && (
      <div className="data-table" data-testid="coupon-list">
        <h3 className="section-heading">Daftar Kupon</h3>
        <table>
          <thead><tr><th>Kode</th><th>Email</th><th>Tier</th><th>Diskon</th><th>Status</th><th>Expired</th></tr></thead>
          <tbody>
            {couponData.coupons.map((c, i) => (
              <tr key={i}>
                <td><code style={{color: '#d9fb06', fontWeight: 700}}>{c.code}</code></td>
                <td>{c.email}</td>
                <td><span className="badge">{c.tier}</span></td>
                <td>{c.discount_percent}%</td>
                <td>{c.is_used ? <span style={{color: '#888680'}}>Digunakan</span> : <span style={{color: '#4ade80'}}>Aktif</span>}</td>
                <td>{c.expires_at ? new Date(c.expires_at).toLocaleDateString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {!couponData?.coupons?.length && (
      <div className="scheduler-empty">
        <Ticket size={48} />
        <p>Belum ada kupon yang dibuat.</p>
        <p className="scheduler-hint">Kupon akan otomatis dibuat saat subscriber memenuhi kriteria engagement, atau Anda bisa buat VIP kupon manual di atas.</p>
      </div>
    )}
  </div>
);

export default CouponsTab;
